import { render, staticRenderFns } from "./WTaskItem.vue?vue&type=template&id=47e17fca&scoped=true&"
import script from "./WTaskItem.vue?vue&type=script&lang=js&"
export * from "./WTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./WTaskItem.vue?vue&type=style&index=0&id=47e17fca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e17fca",
  null
  
)

export default component.exports